/* eslint-disable react/no-unused-class-component-methods */
'use strict';

import React, { Component, Fragment } from 'react'

import FormElement from '@/Form/toolkit/FormElement'

import Loader from '@Pure/Loader'

import Modal from '@Modal/Modal'

import getFormStatus from '@/Form/Functions/getFormStatus'

import { handleChange } from '@/Form/Functions/eventsHandling'

import { isTrue, num } from '@root/utility'

const { app, qwest } = window;

const visibility_options =
[
	{
		name: 'emailing',
		label: 'Une parution format annuaire de votre enseigne comprenant votre logo, le nom de la structure/activité, l’adresse, le numéro de téléphone et la remise consentie'
	},
	{
		name: 'quarter_page',
		label: 'Encart 1/4 de page (85 mm x 46 mm)'
	},
	{
		name: 'semi_page',
		label: 'Encart 1/2 page (85 mm x 95 mm)'
	},
	{
		name: 'full_page',
		label: 'Encart page entière (85 mm x 193 mm)'
	},
	{
		name: 'shared_newsletter',
		label: 'Partagée : newsletter mensuelle de Synergies multi-partenaires (de secteurs non concurrentiel)'
	},
	{
		name: 'specific_newsletter',
		label: 'Spécifique : uniquement dédiée à votre offre'
	}
];

const { moment } = window;

let months_config = [];

months_config.length = 12;

months_config = Array.from(months_config).map(function (empty, i)
{
	const opt =
	{
		value: String(i), label: moment().month(i).add(1, 'year').format('MMMM')
	};

	return opt;
});

const YEAR = moment().month() >= 8
? moment().format('YYYY')
: moment().subtract(1, 'year').format('YYYY');

export default class PartnerRenewalModal extends Component
{
	state =
	{
		open: false,
		data: { },

		form_data: { year: YEAR },

		status_messages: { }
	};

	handleChange = handleChange.bind(this);

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.push(
		{
			event: 'open__PartnerRenewalModal',
			cb: component.open
		});
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		app.delete(
		{
			event: 'open__PartnerRenewalModal',
			cb: component.open
		});
	}

	handleClose = (e, force) =>
	{
		const component = this, props = this.props, state = this.state;

		if (state.loading === true && !force)
		{
			e.stopPropagation();
			return;
		}

		component.setState(
		{
			open: false,
			loading: false
		});
	}

	open = (data) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			open : true,
			partner: data?.partner || { },

			form_data: { year: YEAR },

			info: undefined,
			error: undefined,
			warning: undefined
		});
	}

	renew = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		if (state.loading === true) return;

		component.setState(
		{
			loading: true
		});

		qwest.post('/partner-renewal/renew',
		{
			partner_id: state.partner?.id
		})
		.then(function (xhr, response)
		{
			component.setState(
			{
				error: response.error,
				warning: response.warning,
				info: response.info,

				loading: false
			});

			app.emit('DataList__requestRefresh',
			{
				id: 'Partners-DataList'
			});
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			component.setState(
			{
				error: response.error,
				warning: response.warning,
				info: response.info,

				loading: false
			});
		});
	}

	render ()
	{
		const props = this.props, component = this, state = this.state;

		const loader = state.loading === true ?
		(
			<Loader className="c-loader" bemit={ ['white', 'bg-primary'] } />
		)
		: undefined;


		const YEARS = Object.keys(state.partner?.renewals || { });

		const options = YEARS.map(function (year)
		{
			const label = moment(year, 'YYYY').add(1, 'year').format('YYYY');

			let option =
			(
				<option value={ year } key={ year }>{ label }</option>
			);

			return option;
		});

		if (!YEARS.includes(YEAR))
		{
			options.push(
			(
				<option value={ String(num(YEAR+1)) } key="current">
					{ num(YEAR)+1 }
				</option>
			));
		}

		let renewal_infos;

		const renewal = state.partner?.renewals?.[state.form_data.year] || { };

		if (renewal.renewed === false)
		{
			renewal_infos =
			(
				<p>
					Le renouvellement a été décliné par le partenaire.
				</p>
			);
		}
		else if (renewal.renewed === true)
		{
			const picked_options = visibility_options
			.filter(opt => renewal[opt.name] === true)
			.map(function (option)
			{
				let output =
				(
					<li key={ option.name }>
						{ option.label }
					</li>
				);

				return output;
			});

			const newsletter_months = isTrue(renewal['shared_newsletter']) ?
			(
				<div className="parter-renewal-infos__newsleter-months">
					Mois sélectionnés pour la newsletter partagée&nbsp;:
					{ ' ' }
					{
						months_config
						.filter(opt => isTrue(renewal['newsletter-' + opt.value]))
						.map(opt => opt.label)
						.join(', ')
					}
				</div>
			)
			: undefined;

			const custom_newsletter_months = isTrue(renewal['specific_newsletter']) ?
			(
				<div className="parter-renewal-infos__newsleter-months">
					Mois sélectionnés pour la newsletter spécifique&nbsp;:
					{ ' ' }
					{
						months_config
						.filter(opt => isTrue(renewal['custom_newsletter-' + opt.value]))
						.map(opt => opt.label)
						.join(', ')
					}
				</div>
			)
			: undefined;

			renewal_infos =
			(
				<div className="parter-renewal-infos">

					<div className="c-subtitle">
						<div className="c-subtitle__txt">
							Visibilité WEB
						</div>
					</div>

					<p>
						Modifications à apporter&nbsp;:
						{
							renewal['update-infos'] === true ? ' oui.' : ' non.'
						}
					</p>

					{
						renewal['update-infos'] === true ?
						(
							<p>
								Commentaire&nbsp;:
								{ ' ' }
								{ renewal['update-infos-comment'] || 'Aucun.' }
							</p>
						)
						: undefined
					}

					<div className="c-subtitle">
						<div className="c-subtitle__txt">
							Offre (Remise) consentie
						</div>
					</div>

					<p>
						Modifications à apporter&nbsp;:
						{
							renewal['discount'] === true ? ' oui.' : ' non.'
						}
					</p>

					{
						renewal['discount'] === true ?
						(
							<p>
								Commentaire&nbsp;:
								{ ' ' }
								{ renewal['discount-comment'] || 'Aucun.' }
							</p>
						)
						: undefined
					}

					<p>
						Offre cumulable avec soldes ou promotions&nbsp;:
						{
							renewal['stackable'] === true ? ' oui.' : ' non.'
						}
					</p>

					<p>
						Offre détenteurs carte AXCE/SYNERGIES&nbsp;:
						{
							renewal['axce'] === true ? ' oui.' : ' non.'
						}
					</p>

					<div className="c-subtitle">
						<div className="c-subtitle__txt">
							Options de visibilité choisies
						</div>
					</div>

					{
						picked_options.length === 0 ?
						(
							<p>Aucune option de visibilité choisie.</p>
						)
						:
						(
							<div className="parter-renewal-infos__visibility">

								<ul>
									{ picked_options }
								</ul>

							</div>
						)
					}

					{ newsletter_months }

					{ custom_newsletter_months }

				</div>
			);
		}
		else
		{
			renewal_infos =
			(
				<p>
					Les informations sur le renouvellement n'ont pas encore été transmises par le partenaire.
				</p>
			);
		}

		const reminder = ['stopped', 'renewed'].includes(renewal.status) === false ?
		(
			<button type="button" onClick={ component.renew }
				className="c-btn c-btn--primary c-btn--extra u-margin-top-15">
				Envoyer une demande d'infos manuellement
				{ loader }
			</button>
		)
		: undefined;

		let output =
		(
			<Modal open={ state.open } onClose={ component.handleClose }
				title="Statuts de renouvellement" hide_close={ true }>

				{
					options.length === 0 ? getFormStatus(
					{
						statement: 'Aucune demande n\'a été envoyée.'
					})
					:
					(
						<FormElement className="c-form-element"
							type="select" name="year" data={ state.form_data }
							onChange={ component.handleChange }
							has_empty_option={ false }>
							{ options }
						</FormElement>
					)
				}

				{ renewal_infos }

				{ getFormStatus(state) }

				{ reminder }

				<div className="c-dialog__buttons u-flex u-flex-wrap
					u-content-end u-margin-top-30">

					<button type="button" className="c-btn c-dialog__cancel"
						onClick={ component.handleClose }>
						Fermer
					</button>

				</div>

				{ loader }

			</Modal>
		);

		return output;
	}
}
